import React from 'react';
import classNames from 'classnames';

/**
 * A convenient row component for wrapping a materialize row.
 *
 * @param {array} children
 * @param {string} [className]
 * @param {object} [props]
 * @constructor
 */
const Row = ({children, className, ...props}) => (
    <div {...props} className={classNames('row', className)}>
        {children}
    </div>
);

export default Row;



// WEBPACK FOOTER //
// ./scripts/components/Row.js